var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 946.589 471.245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .not-found{fill:#2f2e41}.not-found-02,.not-found-07{fill:#dd2c41}.not-found-03{fill:none;stroke:#3f3d56;stroke-miterlimit:10}.not-found-04{opacity:.1}.not-found-05{fill:#57b894}.not-found-06{fill:#fff}.not-found-07{opacity:.3}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4150",
    transform: "translate(.006 -5.349)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_67",
    cx: 464.701,
    cy: 30.764,
    fill: "#f2f2f2",
    rx: 464.701,
    ry: 30.764,
    transform: "translate(11.578 415.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    d: "M565.9 324.894c-75.712 0-130.073 48.575-130.073 161.917 0 128.454 54.361 162.457 130.073 162.457s133.312-37.241 133.312-162.457c.002-133.851-57.597-161.917-133.312-161.917zm.5 281.735c-52.44 0-79.837-30.765-79.837-119.735 0-78.5 28.518-119.9 80.958-119.9s80.958 27.193 80.958 119.9c0 86.728-29.64 119.736-82.08 119.736z",
    className: "not-found",
    transform: "translate(-107.433 -215.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    d: "M352.637 561.4h-31.3v-92.186a18.461 18.461 0 0 0-18.461-18.461h-7.335a18.461 18.461 0 0 0-18.461 18.461V561.4h-88.3a10.539 10.539 0 0 1-9.318-15.462l93.453-176.877a18.461 18.461 0 0 0-8.44-25.318l-5.517-2.605a18.461 18.461 0 0 0-24.164 7.99l-113.98 213.214a25.033 25.033 0 0 0-2.956 11.8 25.033 25.033 0 0 0 25.033 25.033h134.186v58.29a22.129 22.129 0 0 0 22.129 22.129 22.129 22.129 0 0 0 22.129-22.129v-58.29h31.3a18.89 18.89 0 0 0 18.89-18.89 18.89 18.89 0 0 0-18.89-18.89z",
    className: "not-found-02",
    transform: "translate(-69.578 -217.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    d: "M1010.633 561.4h-31.3v-92.186a18.461 18.461 0 0 0-18.459-18.461h-7.335a18.461 18.461 0 0 0-18.461 18.461V561.4h-88.3a10.539 10.539 0 0 1-9.318-15.462l93.45-176.882a18.461 18.461 0 0 0-8.439-25.318l-5.517-2.605a18.461 18.461 0 0 0-24.164 7.99L778.812 562.342a25.033 25.033 0 0 0-2.956 11.8 25.033 25.033 0 0 0 25.033 25.033h134.184v58.29a22.128 22.128 0 0 0 22.127 22.13 22.129 22.129 0 0 0 22.129-22.129v-58.29h31.3a18.89 18.89 0 0 0 18.89-18.89 18.89 18.89 0 0 0-18.891-18.89z",
    className: "not-found-02",
    transform: "translate(-147.913 -217.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    d: "M362.44 549.143h-31.3v-92.182a18.461 18.461 0 0 0-18.464-18.461h-7.336a18.461 18.461 0 0 0-18.461 18.461v92.182h-88.3a10.539 10.539 0 0 1-9.318-15.462L282.716 356.8a18.461 18.461 0 0 0-8.44-25.318l-5.517-2.605a18.461 18.461 0 0 0-24.164 7.99L130.617 550.089a25.033 25.033 0 0 0-2.956 11.8 25.033 25.033 0 0 0 25.033 25.033h134.185v58.29a22.129 22.129 0 0 0 22.129 22.129 22.129 22.129 0 0 0 22.129-22.129v-58.29h31.3a18.89 18.89 0 0 0 18.89-18.89 18.89 18.89 0 0 0-18.889-18.89z",
    className: "not-found-03",
    transform: "translate(-70.745 -216.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    d: "M1029.012 549.143h-31.3v-92.182a18.461 18.461 0 0 0-18.465-18.461h-7.334a18.461 18.461 0 0 0-18.461 18.461v92.182h-88.3a10.539 10.539 0 0 1-9.318-15.462L949.29 356.8a18.461 18.461 0 0 0-8.44-25.318l-5.517-2.605a18.461 18.461 0 0 0-24.164 7.99L797.19 550.089a25.033 25.033 0 0 0-2.956 11.8 25.033 25.033 0 0 0 25.033 25.033h134.186v58.29a22.128 22.128 0 0 0 22.129 22.129 22.129 22.129 0 0 0 22.128-22.129v-58.29h31.3a18.891 18.891 0 0 0 18.89-18.89 18.89 18.89 0 0 0-18.891-18.89z",
    className: "not-found-03",
    transform: "translate(-150.101 -216.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    d: "M585.507 313.866c-75.712 0-130.073 48.575-130.073 161.917 0 128.454 54.361 162.457 130.073 162.457S718.819 601 718.819 475.783c0-133.851-57.599-161.917-133.312-161.917zM586 595.6c-52.44 0-79.837-30.765-79.837-119.735 0-78.5 28.518-119.9 80.958-119.9s80.958 27.193 80.958 119.9c0 86.728-29.64 119.736-82.08 119.736z",
    className: "not-found-03",
    transform: "translate(-109.767 -214.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    d: "M595.5 163.234c-.139 0-.278.006-.416.011a11.362 11.362 0 0 1 0 22.71c.138 0 .276.011.416.011a11.365 11.365 0 1 0 0-22.731z",
    className: "not-found-04",
    transform: "translate(-126.392 -157.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    d: "M532.659 163.234c.139 0 .278.006.416.011a11.362 11.362 0 0 0 0 22.71c-.138 0-.276.011-.416.011a11.365 11.365 0 1 1 0-22.731z",
    className: "not-found-04",
    transform: "translate(-117.607 -157.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    d: "M573.064 198.159a11.036 11.036 0 0 1-6.638 2.224h-13.3a11.037 11.037 0 0 1-6.639-2.224z",
    className: "not-found-04",
    transform: "translate(-120.607 -162.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    d: "M1068.288 572.628a18.335 18.335 0 1 0 2.442-35.163l.459 9.437-4.465-8.088a18.266 18.266 0 0 0-9.412 10.327 17.982 17.982 0 0 0-1.055 4.96 18.331 18.331 0 0 0 12.031 18.527z",
    className: "not-found-05",
    transform: "translate(-181.289 -229.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    d: "M1094.533 679.951c-1.576-8.026 5.253-15.141 12-19.765s14.628-9.169 16.93-17.017c3.308-11.28-6.546-21.609-14.215-30.518a110.383 110.383 0 0 1-14.556-21.634 29.784 29.784 0 0 1-3.482-9.837c-.6-5 1-9.975 2.62-14.744q8.086-23.831 17.292-47.263",
    className: "not-found-03",
    transform: "translate(-185.44 -238.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    d: "M1069.138 569.87a18.335 18.335 0 1 0 2.442-35.163l.459 9.437-4.465-8.087a18.266 18.266 0 0 0-9.412 10.327 17.978 17.978 0 0 0-1.055 4.96 18.331 18.331 0 0 0 12.031 18.526z",
    className: "not-found-03",
    transform: "translate(-181.391 -228.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    d: "M1092.3 513.841a18.313 18.313 0 0 1 13.2-11.626l1.51 8.971 2.8-9.422a18.333 18.333 0 1 1-17.505 12.077z",
    className: "not-found-05",
    transform: "translate(-185.455 -222.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    d: "M1093.441 510.163a18.314 18.314 0 0 1 13.2-11.626l1.51 8.971 2.8-9.422a18.333 18.333 0 1 1-17.5 12.077z",
    className: "not-found-03",
    transform: "translate(-185.59 -221.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    d: "M1106.407 620.682a18.333 18.333 0 0 0 16.226-32.615l-2.15 7.241-1.525-9.077a.316.316 0 0 0-.047-.018 18.334 18.334 0 0 0-12.5 34.469z",
    className: "not-found-05",
    transform: "translate(-185.826 -238.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    d: "M1107.407 616.957a18.333 18.333 0 0 0 16.226-32.615l-2.151 7.241-1.525-9.077a.32.32 0 0 0-.047-.018 18.334 18.334 0 1 0-12.5 34.469z",
    className: "not-found-03",
    transform: "translate(-185.945 -237.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    d: "M1086.342 657.146a18.325 18.325 0 1 0 3.533-14.357l8.169 12.295-11.162-6.526a18.162 18.162 0 0 0-.54 8.588z",
    className: "not-found-05",
    transform: "translate(-184.843 -252.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    d: "M1087.192 654.389a18.325 18.325 0 1 0 3.533-14.357l8.169 12.295-11.162-6.526a18.163 18.163 0 0 0-.54 8.588z",
    className: "not-found-03",
    transform: "translate(-184.944 -252.517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    d: "M70.989 624.975a12.046 12.046 0 1 0 1.6-23.1l.3 6.2-2.933-5.314a12 12 0 0 0-6.184 6.785 11.811 11.811 0 0 0-.693 3.259 12.044 12.044 0 0 0 7.9 12.173z",
    className: "not-found-05",
    transform: "translate(-63.054 -240.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    d: "M88.231 695.488c-1.036-5.273 3.452-9.948 7.884-12.986s9.611-6.024 11.123-11.181c2.173-7.411-4.3-14.2-9.339-20.051a72.522 72.522 0 0 1-9.564-14.213 19.567 19.567 0 0 1-2.288-6.463c-.4-3.285.658-6.554 1.721-9.687q5.313-15.658 11.361-31.053",
    className: "not-found-03",
    transform: "translate(-65.781 -247.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    d: "M71.552 623.163a12.046 12.046 0 1 0 1.6-23.1l.3 6.2-2.933-5.313a12 12 0 0 0-6.184 6.785 11.813 11.813 0 0 0-.693 3.259 12.044 12.044 0 0 0 7.9 12.172z",
    className: "not-found-03",
    transform: "translate(-63.121 -240.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    d: "M86.769 586.351a12.032 12.032 0 0 1 8.67-7.639l.992 5.894 1.839-6.191a12.045 12.045 0 1 1-11.5 7.935z",
    className: "not-found-05",
    transform: "translate(-65.791 -236.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    d: "M87.52 583.935a12.032 12.032 0 0 1 8.67-7.639l.992 5.894 1.839-6.19a12.045 12.045 0 1 1-11.5 7.935z",
    className: "not-found-03",
    transform: "translate(-65.881 -236.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    d: "M96.038 656.548a12.045 12.045 0 0 0 10.662-21.429l-1.413 4.757-1-5.964-.031-.012a12.045 12.045 0 1 0-8.215 22.647z",
    className: "not-found-05",
    transform: "translate(-66.035 -252.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    d: "M96.689 654.1a12.045 12.045 0 0 0 10.661-21.429l-1.413 4.757-1-5.964-.031-.012a12.045 12.045 0 1 0-8.217 22.648z",
    className: "not-found-03",
    transform: "translate(-66.113 -252.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    d: "M82.851 680.505a12.04 12.04 0 1 0 2.321-9.433l5.367 8.078-7.333-4.288a11.933 11.933 0 0 0-.355 5.642z",
    className: "not-found-05",
    transform: "translate(-65.389 -256.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    d: "M83.414 678.693a12.04 12.04 0 1 0 2.321-9.433l5.367 8.078-7.333-4.288a11.933 11.933 0 0 0-.355 5.643z",
    className: "not-found-03",
    transform: "translate(-65.456 -256.289)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_72",
    cx: 14.976,
    cy: 19.381,
    className: "not-found",
    rx: 14.976,
    ry: 19.381,
    transform: "translate(408.713 241.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_73",
    cx: 14.976,
    cy: 19.381,
    className: "not-found",
    rx: 14.976,
    ry: 19.381,
    transform: "translate(490.201 241.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    d: "M616.119 540.357c0 8.757-12.228 15.857-27.309 15.857s-27.309-7.1-27.309-15.857c0-7.585 9.171-13.928 21.425-15.478a44.146 44.146 0 0 1 5.885-.379 44.662 44.662 0 0 1 9.8 1.057c10.24 2.282 17.508 8.052 17.508 14.8z",
    className: "not-found",
    transform: "translate(-122.394 -226.66)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_74",
    cx: 14.976,
    cy: 19.381,
    className: "not-found-03",
    rx: 14.976,
    ry: 19.381,
    transform: "translate(412.237 237.217)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    cx: 14.976,
    cy: 19.381,
    className: "not-found-03",
    rx: 14.976,
    ry: 19.381,
    transform: "translate(493.725 237.622)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    cx: 27.309,
    cy: 15.857,
    className: "not-found-03",
    rx: 27.309,
    ry: 15.857,
    transform: "translate(442.63 293.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    d: "M601.738 526.819a4.349 4.349 0 0 1-1.163 2.988 3.822 3.822 0 0 1-2.8 1.24h-8.81a4.109 4.109 0 0 1-3.965-4.228 4.321 4.321 0 0 1 .722-2.415 41.436 41.436 0 0 1 5.885-.4 42 42 0 0 1 9.8 1.128 4.464 4.464 0 0 1 .331 1.687z",
    className: "not-found-06",
    transform: "translate(-125.191 -225.303)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    cx: 4.405,
    cy: 4.405,
    r: 4.405,
    className: "not-found-06",
    transform: "translate(422.809 247.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    cx: 4.405,
    cy: 4.405,
    r: 4.405,
    className: "not-found-06",
    transform: "translate(504.737 247.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    cx: 4.405,
    cy: 4.405,
    r: 4.405,
    className: "not-found-07",
    transform: "translate(509.142 285.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    cx: 4.405,
    cy: 4.405,
    r: 4.405,
    className: "not-found-07",
    transform: "translate(401.666 285.605)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.9b996dd7239d9c80a29704f35086a568.svg";
export { ForwardRef as ReactComponent };